// extracted by mini-css-extract-plugin
export default {"selected":"ToggleChip_selected_EA3-6","deselected":"ToggleChip_deselected_2fnd4"};